import initSchoolSubPage from './schoolSubPage';

export default {
	init() {
		initSchoolSubPage();
	},
	finalize() {},
};
